const appLinks = {
    Android: 'https://play.google.com/store/apps/details?id=com.lmp.buyer',
    IOS: 'https://apps.apple.com/us/app/lehrermarktplatz/id1523303309'
};

export default appLinks;
